import axiosInstance from "../../api/axiosInstance";

// Admin CRUD for tournament-details templates. Backend routes live under
// /api/tournament-details-templates and are gated by the "create-tournaments"
// permission. The axios instance already prefixes the /api/ base + auth token.

export const fetchTournamentDetailsTemplatesAPI = async (page = 1, limit = 10) => {
  const res = await axiosInstance.get(
    `tournament-details-templates/get-templates?page=${page}&limit=${limit}`,
  );
  return res.data;
};

export const createTournamentDetailsTemplateAPI = async (templateData) => {
  const res = await axiosInstance.post(
    "tournament-details-templates/create-template",
    templateData,
  );
  return res.data;
};

export const updateTournamentDetailsTemplateAPI = async (id, templateData) => {
  const res = await axiosInstance.put(
    `tournament-details-templates/update-template/${id}`,
    templateData,
  );
  return res.data;
};

export const deleteTournamentDetailsTemplateAPI = async (id) => {
  const res = await axiosInstance.delete(
    `tournament-details-templates/delete-template/${id}`,
  );
  return res.data;
};
